import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";
import { AuthContext } from "../context/AuthProvider";

export default function useIsAuthenticated(locationPathname) {
  const { user, token, signout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleError = () => {
    signout(() => navigate("/login"));
  };

  const isLoggedIn = async () => {
    if (!user || !token) { 
      return;
    }
    try {
      const response = await fetchWithInterceptor("/api/user/is-logged-in", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        }
      });
      if (!response.ok) {
        handleError();
      }
    } catch (error) {
      handleError();
    }
  };

  useEffect(() => {
    isLoggedIn();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, token, locationPathname]);
}